import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, LayoutDashboard, Package, Hammer } from "lucide-react";

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const doLogout = async () => {
    await logout();
    navigate("/");
  };

  const linkCls = (p) =>
    `text-sm font-medium transition-colors px-3 py-2 rounded-lg ${
      pathname === p ? "text-primary bg-primary/10" : "text-stone-600 hover:text-primary"
    }`;

  return (
    <nav className="sticky top-0 z-50 bg-[#FDFBF7]/85 backdrop-blur-md border-b border-[#E6DFD5]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <img
            src="/favicon.png"
            alt="Taban Mobilya logosu"
            className="h-10 w-10 object-contain group-hover:scale-105 transition-transform"
          />
          <span className="flex flex-col leading-none">
            <span className="font-serif text-xl sm:text-2xl font-bold uppercase tracking-wide text-stone-900 whitespace-nowrap">
              Taban <span className="text-primary">Mobilya</span>
            </span>
            <span className="text-[10px] font-mono uppercase tracking-[0.22em] text-stone-500 mt-1">
              3D Mobilya Atölyesi
            </span>
          </span>
        </Link>

        <div className="flex items-center gap-1 sm:gap-2">
          {user && user.role !== "admin" && (
            <>
              <Link to="/tasarim" data-testid="nav-designer-link" className={linkCls("/tasarim")}>
                <span className="hidden sm:inline">Tasarım Stüdyosu</span>
                <Hammer className="w-4 h-4 sm:hidden" />
              </Link>
              <Link to="/siparislerim" data-testid="nav-orders-link" className={linkCls("/siparislerim")}>
                <span className="hidden sm:inline">Siparişlerim</span>
                <Package className="w-4 h-4 sm:hidden" />
              </Link>
            </>
          )}
          {user && user.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin-link" className={linkCls("/admin")}>
              <span className="hidden sm:inline">Yönetim Paneli</span>
              <LayoutDashboard className="w-4 h-4 sm:hidden" />
            </Link>
          )}

          {user ? (
            <div className="flex items-center gap-3 ml-2">
              <span className="hidden md:block text-sm text-stone-500 max-w-[160px] truncate">
                {user.name || user.email}
              </span>
              <Button
                data-testid="nav-logout-button"
                variant="outline"
                size="sm"
                onClick={doLogout}
                className="rounded-full"
              >
                <LogOut className="w-4 h-4" /> Çıkış
              </Button>
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <Link to="/login">
                <Button data-testid="nav-login-button" variant="ghost" size="sm" className="rounded-full">
                  Giriş Yap
                </Button>
              </Link>
              <Link to="/register">
                <Button data-testid="nav-register-button" size="sm" className="rounded-full">
                  Üye Ol
                </Button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
